// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dn-modal .dn-modal__dialog{border-radius:0;overflow:visible}.dn-modal.gw-modal--error{z-index:9999999}.dn-modal.gw-modal--error h3{margin-bottom:var(--spacing-xs)}.dn-modal.gw-modal--error .dn-modal__dialog{border-left:2px solid var(--color-highlight-error)}@media screen and (min-width:769px){.dn-modal.gw-modal--error .dn-modal__dialog{max-width:50vw}}@media screen and (min-width:993px){.dn-modal.gw-modal--error .dn-modal__dialog{max-width:33vw}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
